import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "partner",
  legacy: {
    data: "partner",
    count: "count",
    fetch: "fetchPartners",
    create: "createOnePartner",
    update: "updatePartner",
    remove: "deletePartner",
    updateState: "updatePartnerState",
  },
});

export const PartnerProvider = Provider;
export const usePartnerContext = useValue;
